import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useStoreCtx } from "src/store";
import Breadcrumbs from "../device-page/components/breadcrumbs";
import Button from "../device-page/components/button";
import OrdersBtn from "../device-page/components/orders-btn/orders-btn";
import { FiltersCatalog } from "./filters";
import s from './index.module.scss';
import Input from "./input";

export type DeviceType = 'tv' | 'smartbox';

export interface ISelectedFilters {
    [props: string]: Set<string>
}

export const DevicesCatalogPage = observer(() => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const httpService = useStoreCtx().appStore

    const [currentType, setCurrentType] = useState<DeviceType>('tv')
    const [searchValue, setSearchValue] = useState<string>('')

    const itemsFull = httpService.jsonTemplate.devices[currentType].items;

    const [selectedFilters, setSelectedFilters] = useState<ISelectedFilters>({});
	const [itemsFiltered, setItemsFiltered] = useState<any[]>([]);

	useEffect(() => {
		setItemsFiltered([]);
		const newItemsFiltered = (httpService.jsonTemplate.devices[currentType].items as any[])
		.filter(device => {        
			if (Object.keys(selectedFilters).length) {
				return Object.keys(selectedFilters).every(key => selectedFilters[key].has(device.specifications.full[key]))
			}
			return device.name.toLowerCase().includes(searchValue.toLowerCase())
		});
		setTimeout(() => {
			setItemsFiltered(newItemsFiltered);
		}, 1);
	}, [currentType]);

    const [mobileFiltersShown, setMobileFiltersShown] = useState(false)

    return (
        <div className={s.wrapper}>  
            <div className={s.headerBlock}>
                <Breadcrumbs steps={[
                    {label: 'Устройства', link: '/'},
                    {label: 'Все устройства', link: '/catalog'},
                ]}/>
            </div>

            <div className={s.catalogWrapper}>
                <div className={s.props}>
                    <div className={s.head}>
                        <Input className={s.search} onChange={(val) => setSearchValue(val)} placeholder="Поиск по названию"/>
                        <div className={s.mobileFilters} onClick={() => setMobileFiltersShown(!mobileFiltersShown)}>
                            <div className={s.filterBtn}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.10072 3.00742C5.5847 3.03169 4.77964 3.1477 4.19572 3.42604C3.90437 3.56492 3.6123 3.80946 3.44312 4.05616C3.0478 4.63258 2.88338 5.35197 3.08883 6.02843C3.17925 6.32612 3.42641 6.76278 3.71097 7.12757C4.01453 7.51671 4.30975 7.83922 5.12832 8.67597C6.02992 9.59759 6.51502 10.0538 7.4702 10.8783L7.9986 11.3345L7.99874 14.1113C7.99889 16.9096 8.00259 17.3496 8.03158 18.0179C8.10096 19.6175 8.34714 20.377 8.92073 20.7612C9.08052 20.8682 9.25179 20.9392 9.4441 20.9783C9.63278 21.0165 9.9769 21.0029 10.2075 20.948C10.928 20.7767 11.7095 20.3652 13.8229 19.0448C14.9617 18.3333 15.26 18.1249 15.4966 17.8755C15.8143 17.5407 15.9334 17.206 15.9756 16.5301C15.9856 16.3692 15.992 15.3128 15.9921 13.8001L15.9921 11.3327L16.306 11.0635C17.2579 10.2471 17.6691 9.86923 18.4313 9.11064C19.2241 8.32158 19.7355 7.78348 20.0601 7.39683C20.5664 6.79374 20.8287 6.34212 20.9468 5.87026C21.1388 5.10272 20.7955 4.1302 20.1706 3.65873C19.6751 3.28487 19.0463 3.11732 17.8356 3.03654C17.7001 3.0275 17.2925 3.0162 16.9297 3.01143C15.9679 2.99878 7.84784 2.99547 7.10072 3.00742ZM17.0251 5.01033C17.9668 5.03673 18.499 5.08918 18.8142 5.18667C18.9167 5.21836 18.9197 5.22084 18.9573 5.30596C18.9784 5.35375 18.9957 5.40583 18.9957 5.4217C18.9957 5.45903 18.8616 5.68211 18.7465 5.83615C18.5111 6.15131 18.2546 6.43327 17.4873 7.22037C16.4737 8.26015 15.9014 8.78614 14.4189 10.0407L13.9977 10.3971L13.9898 13.4691C13.9833 15.9757 13.978 16.5458 13.9609 16.5664C13.9077 16.6306 12.4715 17.5389 11.5266 18.106C10.7384 18.5789 10.138 18.8945 10.1101 18.8504C10.1028 18.8388 10.0967 18.8228 10.0965 18.8149C10.0964 18.8069 10.0857 18.6959 10.0728 18.5682C10.0138 17.9867 10.0115 17.8417 10.0022 14.0961L9.99301 10.3972L9.66723 10.1205C8.09379 8.78426 7.77516 8.49559 6.8544 7.57214C5.92699 6.64204 5.51193 6.19454 5.24425 5.83615C5.12362 5.67466 4.99504 5.45836 4.99523 5.41726C4.99531 5.39898 5.01265 5.34687 5.03375 5.30147C5.07095 5.2215 5.07548 5.21792 5.1806 5.18525C5.49251 5.08833 6.21075 5.022 7.1325 5.00496C7.77674 4.99304 16.5791 4.99783 17.0251 5.01033Z" fill="white"/>
                                </svg>
                            </div>
                            <OrdersBtn minMode/>
                        </div>
                    </div>

                    <FiltersCatalog 
                        itemsFull={itemsFull}
                        currentType={currentType} 
                        onChangeCurrentType={setCurrentType}
                        selectedFilters={selectedFilters}
                        onChangeSelectedFilters={setSelectedFilters}
                        mobileShown={mobileFiltersShown}
                        onChangeMobileShown={setMobileFiltersShown}
                        filteredItemsCount={itemsFiltered.length}
                    />
                </div>

                <div className={s.info}>
                    {itemsFiltered.map((x) => (
                        <Link to={'/catalog/' + currentType + '?key=' + x.keyValue} key={x.name} className={s.card}>
                            <div className={s.image}>
								<div className={s.imageBlock}>
									<img src={x.images.main[0]} />
									{x.uiDiagonal && <div className={s.keyValue}>{`${x.uiDiagonal}''`}</div>}
								</div>
                            </div>

                            <div className={s['card-info']}>
                                <div className={s.title}>
                                    {x.name}
                                </div>

                                <div className={s.specs}>
                                    {Object.keys(x.specifications.short).map(key => (
                                        <p key={key}>
                                            <div className={clsx(s.label, s.small, s.grey)}>
                                                {key}: 
                                            </div>
                                            <div>
                                                {(x.specifications.short as any)[key]}
                                            </div>
                                        </p>
                                    ))}
                                </div>
                            </div>
                        </Link>
                    ))}

                    {!itemsFiltered.length && (
                        <div className={s.notFound}>
                            <div className={s.title}>Ничего не найдено</div>
                            <div className={s.description}>Попробуйте изменить условия поиска</div>
                        </div>
                    )}
                </div>  
            </div>
        </div>
    );
})